import React from "react";
import Lottie from "lottie-react";
import loader from "./Analysing.json";

const AnalysingAnimation = () => (
  <Lottie
    animationData={loader}
    loop
    style={{
      height: "294.03",
      display: "flex",
      justifyContent: "center",
      margin: "0 auto",
    }}
  />
);

export default AnalysingAnimation;
